<template>
    <condimentsComp />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

const condimentsComp = defineAsyncComponent(() => import('@/components/managementPages/condimentsPage/condimentsComp.vue'))
</script>